/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';
import { PrintService } from './@core/service';
import { ICON_ITEMS_GREATLAB } from './@theme/helpers/great-lab-icon-pack';

@Component({
  selector: 'ngx-app',
  template: `
 <div [class.isPrinting]="true">

<router-outlet name="print"></router-outlet>
 
<router-outlet></router-outlet>
 

</div>
 `

})
export class AppComponent implements OnInit {


  onPrintInvoice() {
  
  }
  constructor(
    private iconLibraries: NbIconLibraries,
    public printService: PrintService
  ) {

    this.iconLibraries.registerSvgPack('great-pack', ICON_ITEMS_GREATLAB);
  }

  ngOnInit(): void {
  }
}
